import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFinanceiroTotaisPorCategoria } from '@/features/relatorio/page/financeiro/totais-por-categoria/RelatorioFinanceiroTotaisPorCategoria';

export const Route = createFileRoute('/a/relatorio/financeiro/totais-por-categoria')({
    component: RelatorioFinanceiroTotaisPorCategoria,
});
